<p-confirmDialog
  [key]="deleteConfirmKey"
  appendTo="body"
  [baseZIndex]="12001"
  [style]="{ width: '28rem' }" />

<p-dialog
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '760px' }"
  [dismissableMask]="true"
  (onHide)="close()"
  (onShow)="onDialogShow()">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-8 text-2xl font-[600] text-[var(--p-slate-900)]">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <use xlink:href="assets/images/icon-library.svg#lightbulb"></use>
      </svg>
      Skills Gallery
    </div>
  </ng-template>

  <div class="mb-16 flex justify-end">
    <p-button label="Create skill" size="small" (onClick)="startCreate()" />
  </div>

  @if (loading()) {
    <p class="m-0 text-sm text-[var(--p-slate-500)]">Loading skills…</p>
  } @else if (errorText()) {
    <p class="m-0 text-sm text-[var(--p-red-600)]">{{ errorText() }}</p>
  } @else if (items().length === 0) {
    <p class="m-0 text-sm text-[var(--p-slate-500)]">No skills yet. Create one here, or type /create-skill in the chat box.</p>
  } @else {
    <div class="flex max-h-[60vh] flex-col gap-12 overflow-auto">
      @for (skill of items(); track skill.id) {
        <article class="flex flex-col gap-8 rounded-[10px] border border-[var(--p-gray-200)] p-12">
          <div class="flex items-start justify-between gap-12">
            <div class="flex min-w-0 flex-col gap-2">
              <span class="text-sm font-semibold text-[var(--p-gray-900)]">/{{ skill.slash }}</span>
              <span class="text-xs text-[var(--p-slate-500)]">{{ skill.title }}</span>
            </div>
            <div class="flex shrink-0 gap-8">
              <button
                type="button"
                class="flex h-28 w-28 items-center justify-center rounded-md text-[var(--p-slate-700)] hover:bg-[var(--p-gray-100)]"
                pTooltip="Edit"
                tooltipPosition="top"
                (click)="startEdit(skill)"
                aria-label="Edit skill">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <use xlink:href="assets/images/icon-library.svg#pencil"></use>
                </svg>
              </button>
              <button
                type="button"
                class="flex h-28 w-28 items-center justify-center rounded-md text-[var(--p-red-600)] hover:bg-[var(--p-red-50)]"
                pTooltip="Delete"
                tooltipPosition="top"
                [disabled]="deletingId() === skill.id"
                (click)="confirmDelete(skill)"
                aria-label="Delete skill">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <use xlink:href="assets/images/icon-library.svg#trash-2"></use>
                </svg>
              </button>
            </div>
          </div>
          <p class="m-0 text-sm leading-snug text-[var(--p-slate-700)]">{{ promptPreview(skill) }}</p>
          @if (parameterLabel(skill)) {
            <span class="text-xs text-[var(--p-slate-500)]">Asks for {{ parameterLabel(skill) }}</span>
          }
        </article>
      }
    </div>
  }
</p-dialog>

<app-create-skill
  [(visible)]="editVisible"
  [editing]="editingSkill"
  (skillCreated)="onSkillSaved($event)" />
